import { datadogRum } from "@datadog/browser-rum";

export const loadDataDogRum = () => {
    datadogRum.init({
        applicationId: window['ES_PATIENT_HUB']?.config?.datadog?.rumCredentials?.applicationId,
        clientToken: window['ES_PATIENT_HUB']?.config?.datadog?.rumCredentials?.clientToken,
        site: 'datadoghq.com',
        service: 'patient-hub-mfes',
        env: window['ES_PATIENT_HUB']?.config?.instance?.environment,
        // version: window['ES_PATIENT_HUB']?.config?.instance?.version,
        allowedTracingUrls: window['ES_PATIENT_HUB']?.config?.datadog?.allowedTracingUrls,
        traceSampleRate: 10,
        sessionSampleRate: 25,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: false,
        trackLongTasks: false,
        defaultPrivacyLevel: 'mask-user-input',
        allowFallbackToLocalStorage: true,
        storeContextsAcrossPages: true,
        telemetrySampleRate: 10,
        trackSessionAcrossSubdomains: true,
        // beforeSend: (event) => {
        //     console.log('Datadog RUM Event:', event);
        //     return true;
        // },
    });
};
